export interface ReportConfigResource {
  id: string;
  type: string;
  slot_id?: string;
  name?: string;
}

export interface BuildReportConfigDataInput {
  reportId: string;
  resources?: ReportConfigResource[];
  asAtDate?: string;
}

/** Build the data payload for POST /report-configs. */
export function buildReportConfigData(input: BuildReportConfigDataInput): Record<string, unknown> {
  const data: Record<string, unknown> = { report_id: input.reportId };

  if (input.resources?.length) {
    data.resources = input.resources;
  }
  if (input.asAtDate) {
    data.as_at = input.asAtDate;
  }

  return data;
}
